import {
  getResponseByMode
} from './utils';

export const path = 'M32.8292 40.8284C31.2671 42.3905 28.7344 42.3905 27.1723 40.8284L13.246 26.9021C12.4958 26.1519 12.0744 25.1345 12.0744 24.0737C12.0744 23.0128 12.4958 21.9954 13.246 21.2452L27.1723 7.31889C28.7344 5.75679 31.2671 5.7568 32.8292 7.31889C34.3913 8.88099 34.3913 11.4136 32.8292 12.9757L21.7312 24.0737L32.8292 35.1716C34.3913 36.7337 34.3913 39.2663 32.8292 40.8284Z';
export const dadataToken = getResponseByMode('d2bb2e2a4c19c903bdf6302ce5279838825b4768', '2fea96f5ac652a320abe48a94e29aa175034bf62');
export const ZOOM = 8;
export const MIN_ZOOM = 9;
export const MAX_ZOOM = 15;
export const FIAS_ID = document.body.dataset.fiasId;
export const DEBOUNCE_INTERVAL = 500;
export const CAPTCHA_KEY = '6LdWEKonAAAAAJnKIIaUP2EE-etKxJOCbDTsy2fH';
export const DISABLE_SHOW_CLS = ['disabled', 'disabled--show'];
export const DISABLE_CLS = 'disabled';
export const CLASS_DISABLES = 'uf_disabled';
export const CLASS_HIDE = 'uf_hide';
export const CLASS_SELECTED = 'uf_label_selected';
export const ENTER_KEY = 'Enter';
export const ESC_KEY = 'Escape';
export const RUBLE = ' руб.';
export const NULL_TEXT = '0' + RUBLE;
export const FREE_TEXT = 'Бесплатно';
export const PREFIX = 'FixMobile_';
export const CASH_TEXT = 'Наличная и безналичная оплата';
export const TUMBLER = '.tumbler';
export const DELIVERY_TYPE = 'delivery';
export const PAYMENT_TYPE = 'payment';
export const MIN_DESKTOP_MEDIA = '1200px';
export const FILTERS = {
  'Все': true,
  'СДЭК': true,
  'Энергия': true
};
export const Company = {
  CDEK: 'СДЭК',
  ENERGY: 'Энергия',
};
export const DeliveryName = {
  POST: 'shipping_method_3',
  POST_CASH: 'shipping_method_10',
  CDEK: 'shipping_method_7',
  CDEK_COURIER: 'shipping_method_24',
  EMS: 'shipping_method_11',
  DL: 'shipping_method_14',
  ENERGY: 'shipping_method_1',
};
export let paymentsState = {
  'shipping_method_none': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': true,
  },
  'shipping_method_3': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': false,
  },
  'shipping_method_10': {
    'sber': false,
    'online': false,
    'bank': false,
    'cash': true,
  },
  'shipping_method_7': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': true,
  },
  'shipping_method_24': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': true,
  },
  'shipping_method_11': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': false,
  },
  'shipping_method_14': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': false,
  },
  'shipping_method_1': {
    'sber': true,
    'online': true,
    'bank': true,
    'cash': false,
  },

  setState(id, payment, bool) {
    this[id][payment] = bool;
  }
};
export const variants = {
  clothing: {
    sizes: ['clothingSize', 'height']
  },
  shoes: {
    sizes: ['shoeSize']
  },
  hats: {
    sizes: ['hatSize']
  },
  shirts: {
    sizes: ['shirtSize', 'height'],
    link: ['collarSize']
  },
  trousers: {
    sizes: ['trousersSize', 'height']
  },
  gloves: {
    sizes: ['ruSize'],
    link: ['intSize']
  }
};
export const SELECTPICKER_OPTION = {
  noneResultsText: 'Не найдено по запросу {0}',
  noneSelectedText: 'Ничего не выбрано',
  selectAllText: 'Выбрать всё',
  deselectAllText: 'Сбросить всё',
  size: 10,
};
export const TIMEOUT = 1000;
export const CategoryAction = {
  SORT: 'sort',
  FILTERS: 'filters',
  LOADMORE: 'loadmore'
};
export const UpdateType = {
  MEDIUM: 1,
  LARGE: 2
};
export const DELAY = 500;
export const SearchParams = {
  GOOD: ['query', 'start'],
  BAD: ['urlUnijaxFilter', 'search']
};
export const LAZY_PRODUCTS_URL = {
  'popular': '/index.php?option=com_jshopping&controller=products&task=ajax_products&type=top',
  'latest': '/index.php?option=com_jshopping&controller=products&task=ajax_products&type=visited',
  'related': '/index.php?option=com_jshopping&controller=products&task=ajax_products&type=product_related&product_id='
};
export const LAZY_PRODUCTS_CLASS = '.lazy-products';
export const FilterId = {
  SHOES: 'filter-5',
  HATS: 'filter-7',
  CLOTHES: 'filter-11',
};
